import { API } from '..';

export interface PhoneVerifyStatus {
  enabled: boolean;
  phoneVerified: boolean;
  phoneNumber?: string | null;
  trialEndsAt?: string | null;
  mustVerify: boolean;
  daysLeft?: number | null;
}

export const getPhoneVerifyStatus = () =>
  API.get<PhoneVerifyStatus>('/v1/identity-service/phone-verify/status').then((r) => r.data);

export interface SendOtpResult {
  sent?: boolean;
  isMock?: boolean;
  devOtp?: string | null;
  alreadyVerified?: boolean;
}

export const sendPhoneOtp = (phoneNumber: string) =>
  API.post<SendOtpResult>('/v1/identity-service/phone-verify/send-otp', { phoneNumber }).then((r) => r.data);

export const confirmPhoneOtp = (phoneNumber: string, code: string) =>
  API.post<{ verified: boolean }>('/v1/identity-service/phone-verify/confirm', { phoneNumber, code }).then(
    (r) => r.data
  );
